import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';

import { ProductFiltersSchema } from 'core/schemas/productFilters';
import { FormSubmitHandler } from 'Elements/Form';

import FilterProducts from './FilterProducts';
import ProductsTable from './ProductsTable';

const Height100 = styled.div`
  height: 100%;
`;
const Width100 = styled.div`
  width: 100%;
  max-width: 250px;
`;

export default function ProductList() {
  const [params, setParams] = useState();

  const onSubmit: FormSubmitHandler<ProductFiltersSchema> = values => {
    setParams(serialize(values));
  };

  return (
    <Grid container direction="row" component={Height100}>
      <Grid item xs component={Width100}>
        <FilterProducts onSubmit={onSubmit} />
      </Grid>

      <Grid item sm={12} md={8} component={Height100}>
        <ProductsTable params={params}></ProductsTable>
      </Grid>
    </Grid>
  );
}

const serialize = (values: any): any => {
  const params = JSON.parse(JSON.stringify(values));

  return params;
};
